import { useCallback, useState } from "react";
import { UserInterfaceState } from "../../../shared/Enum";
import { getRoleList } from "../../../api/Role/Repository";
import { RoleEntity } from "../../../api/Role/Entity/RoleEntity";
import { GetProfileDto } from "../../../api/Identity/Dto";
import { getProfile } from "../../../api/Identity/RemoteRepository";
import { ProfileEntity } from "../../../api/Identity/Entity";

interface Return {
  data: {
    UIState: UserInterfaceState;
    roleMenu: RoleEntity;
    latestProfile: ProfileEntity;
  };
  method: {
    onGetRoleMenuAccess(filter: string): void;
    onGetLatestProfile(payload: GetProfileDto): void;
  };
}

export default function useViewModel(): Return {
  const [UIState, setUIState] = useState<UserInterfaceState>(
    UserInterfaceState.Idle
  );

  const [roleMenu, setRoleMenu] = useState<RoleEntity>({
    access: [],
    id: "",
    name: "",
  });

  const [latestProfile, setLatestProfile] = useState<ProfileEntity>({
    binusianId: "",
    binusianName: "",
    businessUnit: "",
    department: "",
    email: "",
    isActive: false,
    roleId: "",
    title: "",
  });

  const onGetRoleMenuAccess = useCallback(
    async (filter: string) => {
      setUIState(UserInterfaceState.Loading);
      await getRoleList(filter)
        .then((res) => setRoleMenu(res[0]))
        .then(() => setUIState(UserInterfaceState.Success))
        .catch((error) => {
          console.log("Error fetching data:", error);
          setUIState(UserInterfaceState.Error);
        });
    },
    [getRoleList]
  );

  const onGetLatestProfile = useCallback(
    async (payload: GetProfileDto) => {
      setUIState(UserInterfaceState.Loading);
      await getProfile(payload)
        .then((res) => setLatestProfile(res))
        .then(() => setUIState(UserInterfaceState.Success))
        .catch((error) => {
          console.log("Error fetching data:", error);
          setUIState(UserInterfaceState.Error);
        });
    },
    [getProfile]
  );

  return {
    data: {
      UIState,

      roleMenu,
      latestProfile,
    },
    method: {
      onGetRoleMenuAccess,
      onGetLatestProfile,
    },
  };
}
